import api from '../callApi';
import { parseAddressNumber, parseAddressStreet } from '../addressParser';

const apiCompleteFindPollingStation = (apiRequestData, values, actionCompletedTime) => {
    const request = {
        ...apiRequestData,
        street: parseAddressStreet(values.address),
        streetNo: parseAddressNumber(values.address),
        zipCode: values.postalCode,
        actionCompletedTime: actionCompletedTime
    };

    return api.post('Widget/CompleteFindPollingStationAsync', request).then(response => {
        // return {
        //   counter: 107,
        //   election: {
        //     name: 'Mayor Elections',
        //     electionDay: '20 Sep 2018',
        //   },
        //   pollingStation: {},
        // }
        // return {
        //   counter: 107,
        //   election: {
        //     name: 'Mayor Elections',
        //     electionDay: '20 Sep 2018',
        //   },
        //   pollingStation: {
        //     address: {
        //       name: 'string',
        //       country: 'US',
        //       state: 'NY',
        //       city: 'New York',
        //       zipCode: '10001',
        //       street: '8th Ave',
        //       streetNo: '224',
        //     },
        //   },
        // }
        return response;
    });
};

export default apiCompleteFindPollingStation;



// WEBPACK FOOTER //
// ./src/utils/findPollingStation/findPollingStationApi.js